// extracted by mini-css-extract-plugin
export default {"bonusBadge":"styles_bonusBadge__DSSei","inlineBonusBadge":"styles_inlineBonusBadge__nYw4j","floatingBonusBadge":"styles_floatingBonusBadge__CFo+n"};